// extracted by mini-css-extract-plugin
export default {"root":"NrWEQ","prev":"jKq9N","next":"QfwLu","icon":"OHHNG"};